import { render } from "./ThreadSystemMessage.vue?vue&type=template&id=6720fb31&scoped=true"
import script from "./ThreadSystemMessage.vue?vue&type=script&lang=js"
export * from "./ThreadSystemMessage.vue?vue&type=script&lang=js"

import "./ThreadSystemMessage.vue?vue&type=style&index=0&id=6720fb31&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6720fb31"]])

export default __exports__